<template>
  <div class="obituary-info__wraps">
    <div class="obituary-info__wrap">
      <span class="obituary-info__title">빈소</span>

      <span class="obituary-info__content">
        {{ binsoName }}
      </span>
    </div>

    <div
      v-if="enterDate && obituaryDetail.id !== 19964"
      class="obituary-info__wrap"
    >
      <span class="obituary-info__title">입실</span>
      <span class="obituary-info__content">
        {{ enterDate }}
      </span>
    </div>

    <div
      v-if="isDsbioObituary || (casketDate && !endCasketVisibleCheck)"
      class="obituary-info__wrap"
    >
      <span class="obituary-info__title">입관</span>
      <span class="obituary-info__content">
        {{ casketDate }}
      </span>
    </div>

    <div v-if="obituaryDetail.id !== 19964" class="obituary-info__wrap">
      <span class="obituary-info__title">발인</span>

      <span class="obituary-info__content">
        {{ endDate }}
      </span>
    </div>

    <div v-if="obituaryDetail.id !== 19964" class="obituary-info__wrap">
      <span class="obituary-info__title">장지</span>

      <span class="obituary-info__content" style="white-space: pre-line">
        {{ placeName }}
      </span>
    </div>

    <div v-if="obituaryNotice" class="obituary-info__wrap">
      <span class="obituary-info__title">알림글</span>
      <span class="obituary-info__contents" style="white-space: pre-line">
        {{ obituaryNotice }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ObituaryMapInfo",

  props: ["obituaryDetail"],

  computed: {
    // 빈소명
    binsoName() {
      const addrName = this.obituaryDetail?.addrName || " ";
      const mortuaryName = this.obituaryDetail?.mortuaryName || " ";
      return `${addrName} ${mortuaryName}`;
    },
    isDsbioObituary() {
      return this.obituaryDetail?.eventNo;
    },

    enterDate() {
      const enterDate = this.obituaryDetail?.enterDate;

      if(!enterDate) {
        return null;
      }

      return enterDate
      ? this.KOREAYYYYMMDDEEHHMMDate(enterDate.replace("요일", ""))
      : null;
    },

    casketDate() {
      const casketDate = this.obituaryDetail?.casketDate;

      if (!this.isDsbioObituary && !casketDate) {
        return null;
      }

      if (
        !this.isDsbioObituary &&
        casketDate &&
        this.obituaryDetail?.endCasketVisibleCheck
      ) {
        return "미정";
      }

      return casketDate
        ? this.KOREAYYYYMMDDEEHHMMDate(casketDate.replace("요일", ""))
        : "미정";
    },

    endCasketVisibleCheck() {
      return this.obituaryDetail?.endCasketVisibleCheck;
    },

    endDate() {
      // 발인일시와 발인 시간이 미정이 아닌 경우
      const endDate = this.obituaryDetail?.endDate;
      if (
        endDate &&
        !this.obituaryDetail?.endTimeVisibleCheck &&
        !this.obituaryDetail?.endTimeDisable
      ) {
        return this.KOREAYYYYMMDDEEHHMMDate(endDate.replace("요일", ""));
      } else if (
        // 발인 시간은 미정인 경우
        endDate &&
        !this.obituaryDetail?.endTimeVisibleCheck &&
        this.obituaryDetail?.endTimeDisable
      ) {
        this.KOREAYYYYMMDDDate(endDate.replace("요일", ""));
      } else {
        return "미정";
      }
    },

    placeName() {
      const place = this.obituaryDetail?.place;

      return place?.trim() !== "" ? place : "미정";
    },

    obituaryNotice() {
      return this.obituaryDetail?.memberText;
    }
  }
};
</script>

<style></style>
